<template>
  <section>
    <!-- 统计文字 -->
    <el-row class="total">
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-question sicon one"></i>
        <span class="tjContent">
          <div>点击人数</div>
          <div class="numText one">{{cdata.total.click_uv||'0'}}</div>
        </span>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-success sicon two"></i>
        <span class="tjContent">
          <div>成功人数</div>
          <div class="numText two">{{cdata.total.clickok_uv||'0'}}</div>
        </span>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-news sicon three"></i>
        <span class="tjContent">
          <div>成功率</div>
          <div class="numText three">{{cdata.total.clickok_per||'0'}}%</div>
        </span>
      </el-card>
      <!-- <el-col :span="4" :offset="6">点击人数:{{cdata.total.click_uv}}人</el-col>
      <el-col :span="4">成功人数:{{cdata.total.clickok_uv}} 人</el-col>
      <el-col :span="4">成功率:{{cdata.total.clickok_per}}%</el-col>-->
    </el-row>
    <el-row class="selectRow">
      <el-col style="min-width:600px" :span="14">
        <el-row :gutter="10">
          <el-button
            icon="el-icon-arrow-left"
            circle
            @click="$router.push({path:'/creativeData/index'})"
          ></el-button>
          <el-button type="primary" plain @click="changeDate(1)">昨天</el-button>
          <el-button type="primary" id="seven" plain @click="changeDate(7)">最近7天</el-button>
          <el-date-picker
            v-model="dateVal"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="今天"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-row>
      </el-col>
      <el-col :span="10">
        <div style="float:right;min-width:150px">
          <el-row :gutter="10">
            <el-button type="primary" round @click="toogleChart">图表</el-button>
            <el-dropdown class="dropdown" @command="themeFilter">
              <el-button type="normal" class="dropdown">
                {{tText}}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown" class="dropdown-menu">
                <el-dropdown-item command>所有类型</el-dropdown-item>
                <el-dropdown-item v-for="(v,i) in config" :key="i" :command="i">{{v[0]}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-input
              style="width:170px"
              @clear="getList"
              @keyup.enter.native="search"
              ref="input"
              class="search"
              v-model="pdata.kw"
              clearable
              placeholder="请输入创意名称/ID"
              :suffix-icon="pdata.kw.length>0?'':'el-icon-search'"
            ></el-input>
          </el-row>
        </div>
      </el-col>
    </el-row>

    <!-- 图表 -->
    <el-row style="min-width:1200px" v-show="!isChartShow">
      <div id="chart" style="width:100%; height:500px;"></div>
    </el-row>
    <!--列表-->
    <el-table :data="cdata.list" style="width: 100%;min-width:1200px" stripe row-key="id">
      <!-- <el-table-column type="selection"></el-table-column> -->
      <el-table-column prop="name" label="投放的小程序" align="center"></el-table-column>
      <el-table-column prop="name" label="投放的广告位" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.name+'-'+scope.row.type_name}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="name" label="创意类型" align="left"></el-table-column> -->
      <el-table-column prop="type_name" label="广告位类型" align="center"></el-table-column>
      <el-table-column prop="click_uv" label="点击人数" align="center"></el-table-column>
      <el-table-column prop="clickok_uv" label="成功人数" align="center"></el-table-column>
      <el-table-column prop="clickok_per" label="点击率" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.clickok_per+'%'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="income" label="收入预估" align="center"></el-table-column>
    </el-table>
    <div class="pageRow">
      <el-pagination
        class="pagination"
        @size-change="SizeChange"
        @current-change="CurrentChange"
        :current-page.sync="pdata.page"
        :page-sizes="[20, 40, 60, 80]"
        :page-size="pdata.perpage"
        background
        layout="sizes, prev, pager, next, jumper"
        :total="pdata.perpage*maxPage"
      ></el-pagination>
    </div>
    <el-dialog title="编辑创意组合" :visible.sync="editDialog">
      <el-form :model="group"></el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="editDialog = false">确 定</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import { scdetail } from "../../api/api";
import echarts from "echarts";

export default {
  data() {
    return {
      isChartShow:true,
      chartColumn: null,
      timer: null,
      pdata: {
        page: 1,
        perpage: 20,
        type: "",
        kw: "",
        app_id: "",
        creative_id: 1,
        sdate: new Date(new Date().getTime() - 3600 * 7 * 1000 * 24)
          .toISOString()
          .slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
        // sdate: "2019-04-01",
        // edate: "2019-04-01",
      },
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {},

      dateVal: [
        new Date(new Date().getTime() - 3600 * 7 * 1000 * 24)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      cdata: { total: {}, chat: {}, list: [], max_page: 1 }, //所有数据
      option: {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["点击人数", "点击成功数", "点击率"]
        },
        toolbox: {
          show: true,
          feature: {
            magicType: { show: true, type: ["tiled", "stack"] },
            dataView: { show: true },
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "点击人数",
            type: "line",
            smooth: true,
            data: []
          },
          {
            name: "点击成功数",
            type: "line",
            smooth: true,
            data: []
          },
          {
            name: "点击率",
            type: "line",
            smooth: true,
            data: []
          }
        ],
        color: [
          "#61c0a0",
          "#ee4f54",
          "#8ec1b0",
          "#a6e8ba",
          "#ceead4",
          "#f2e247",
          "#f6e98b",
          "#f77b31",
          "#fc9656",
          "#ec151a",
          "#ee4f54",
          "#ee2159",
          "#fbaaa6"
        ]
      }
    };
  },
  watch: {
    dateVal: {
      handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },
      deep: true
    }
  },
  methods: {
    getList() {
      var p = "";
      for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      scdetail(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.cdata = res.data;
          this.option.xAxis.data = res.data.chart.date;
          this.option.series[0].data = res.data.chart.click_uv;
          this.option.series[1].data = res.data.chart.clickok_uv;
          this.option.series[2].data = res.data.chart.clickok_per;
          this.drawColumnChart();
        }
      });
    },
    getConfig() {
      if (this.$store.config) {
        this.config = this.$store.config.ad_space_type;
        this.tags = this.$store.config.product_tag;
      } else {
        setTimeout(() => {
          this.getConfig();
        }, 50);
      }
    },
    drawColumnChart() {
      this.chartColumn = echarts.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    themeFilter(s) {
      this.tText = s === "" ? "请选择创意类型" : this.config[s][0];
      this.pdata.type = s === "" ? "" : this.config[s][1];
      this.getList();
    },
    search() {
      // 有问题;
      this.getList();
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate(s) {
      this.dateVal = [
        new Date(new Date().getTime() - 3600 * 1000 * 24 * s)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ];
      // this.getList();
    },
    toogleChart() {
      this.isChartShow = !this.isChartShow;
      var that = this;
      setTimeout(() => {
        that.chartColumn.resize();
      }, 100);
    }
  },

  mounted() {
    this.getConfig();
    this.pdata.creative_id = this.$route.params.id;
    this.getList();
    document.getElementById("seven").focus();
  }
};
</script>

<style lang="scss">
.el-button + .el-button {
  margin-left: 0;
}
#chart > div {
  margin: 0 auto;
}
</style>






// WEBPACK FOOTER //
// cDetail.vue?34a2f166